var map = {
	"./advanced": 88408,
	"./advanced.hbs": 32596,
	"./advanced.js": 88408,
	"./basic": 49855,
	"./basic.hbs": 90738,
	"./basic.js": 49855,
	"./basic.module.scss": 4869,
	"./custom": 20901,
	"./custom.hbs": 32633,
	"./custom.js": 20901,
	"./custom.module.scss": 97894,
	"./diagnosis-value": 27885,
	"./diagnosis-value.hbs": 59306,
	"./diagnosis-value.js": 27885,
	"./empty": 98451,
	"./empty.hbs": 38675,
	"./empty.js": 98451,
	"./footer": 76892,
	"./footer.hbs": 63697,
	"./footer.js": 76892,
	"./top-part": 31422,
	"./top-part.hbs": 91771,
	"./top-part.js": 31422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84753;